import { Check } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconTick(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Check />
    </IconWrapper>
  );
}
